import { useState } from "react";
import { Controller, useForm } from "react-hook-form";

import { intl } from "LocaleWrapper";

import { FormGroup } from "@cofano/cck";

import { request } from "components/utils/Request2";
import { FormDialog, FormDialogComponentProps } from "components/dialogs/Dialogs";
import FormField from "components/cck/FormField";

import { WaterLevel, WaterLevelForm } from "types/index";
import WaterLevelSelect from "../selects/WaterLevelSelect";

const AddWaterLevelDialog = ({ open, onClose, entity, onSave }: FormDialogComponentProps<WaterLevel[]>) => {

	const [ loading, setLoading ] = useState(false);

	const defaultValues = {
		levels: undefined,
	};

	const { control, handleSubmit, formState, reset } = useForm<WaterLevelForm>({
		defaultValues: defaultValues,
	});

	const handleOnClose = () => {
		onClose();
		reset(defaultValues);
	};

	const save = (data: WaterLevelForm) => {

		setLoading(true);

		const list = entity ? [ ...entity.map(it => it.id) ] : [];

		if (data.levels) {
			data.levels.forEach(it => list.push(it.id));
		}

		request({
			method: "POST",
			body: list,
			url: "waterlevels/subscriptions/personal",
		}).then(() => {
			handleOnClose();
			onSave();
		}).finally(() => {
			setLoading(false);
		});
	};

	return (
		<FormDialog
			open={open}
			onClose={handleOnClose}
			title={intl.formatMessage({ id: "WATER_LEVELS" })}
			form="waterLevelForm"
			loading={loading}>
			<form onSubmit={(event) => void handleSubmit(save)(event)} id="waterLevelForm">
				<FormGroup label={intl.formatMessage({ id: "WATER_LEVELS" })} overflow="hidden" required>
					<FormField name="levels" errors={formState.errors}>
						<Controller
							name='levels'
							control={control}
							rules={{ required: true }}
							render={({ field }) => (
								<WaterLevelSelect
									{...field}
									getOptionDisabled={(option: WaterLevel) => {
										const optionExist = entity?.find(it => it.id === option.id);
										return optionExist ? true : false;
									}}
									multiple={true} />
							)} />
					</FormField>
				</FormGroup>
			</form>
		</FormDialog>
	);
};

export default AddWaterLevelDialog;
